import { SalesReport } from "@/components/reports/SalesReport";
import { StockReport } from "@/components/reports/StockReport";
import { FinancialReport } from "@/components/reports/FinancialReport";
import { CustomerReport } from "@/components/reports/CustomerReport";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export function Reports() {
  return (
    <div className="h-[calc(100vh-64px)] overflow-hidden">
      <Tabs defaultValue="financial" className="h-full flex flex-col">
        <TabsList className="w-full justify-start bg-[#222831] border-b border-[#2A2F3C] p-0 h-12 overflow-x-auto flex-shrink-0">
          <TabsTrigger 
            value="financial" 
            className="data-[state=active]:bg-[#0073B7] data-[state=active]:text-white px-8 h-12 rounded-none text-gray-300 whitespace-nowrap"
          >
            Relatório Financeiro
          </TabsTrigger>
          <TabsTrigger 
            value="stock" 
            className="data-[state=active]:bg-[#0073B7] data-[state=active]:text-white px-8 h-12 rounded-none text-gray-300 whitespace-nowrap"
          >
            Relatório de Estoque
          </TabsTrigger>
          <TabsTrigger 
            value="customers" 
            className="data-[state=active]:bg-[#0073B7] data-[state=active]:text-white px-8 h-12 rounded-none text-gray-300 whitespace-nowrap"
          >
            Relatório de Clientes
          </TabsTrigger>
        </TabsList>
        
        <div className="flex-1 overflow-y-auto bg-[#1A1F2C]">
          <div className="container mx-auto py-6 px-4">
            <TabsContent value="financial" className="mt-0">
              <FinancialReport />
            </TabsContent>
            <TabsContent value="stock" className="mt-0">
              <StockReport />
            </TabsContent>
            <TabsContent value="customers" className="mt-0">
              <CustomerReport />
            </TabsContent>
          </div>
        </div>
      </Tabs>
    </div>
  );
}